import * as moment from 'moment-timezone';
import { Moment } from 'moment-timezone';

export class MomentDateBuilder {
  static format(date: string, timezone?: string): Moment {
    if (timezone) {
      return moment.tz(date, timezone);
    }
    return moment(date);
  }
}
